import { useAuth } from "@workos-inc/authkit-react";
import { useEffect } from "react";
import { useNavigate } from "react-router";

const AuthPage = () => {
  const navigate = useNavigate();
  const { user, signIn } = useAuth();

  useEffect(() => {
    if (!user) {
      signIn();
    }
  }, [user, signIn]);

  if (user) {
    // Auth callback may land on "/" (with ?code=...), so we always go through "/"
    // and let RootRedirect decide between returnTo vs /home.
    navigate("/", { replace: true });
  }

  return null;
};

export default AuthPage;
